import { Button } from "@material-ui/core";
import styled from "styled-components";
import theme from "@src/Tools/MuiTheme";

export const STDoneButton = styled(Button)`
  && {
    margin: ${theme.spacing(1)}px;
    color: #fff;
    background-color: #3f51b5;
    padding: 6px 16px;
    border-radius: 4px;
  }
`;

export const STClearButton = styled(Button)`
  && {
    margin: ${theme.spacing(1)}px;
    background-color: #e0e0e0;
    color: rgba(0, 0, 0, 0.87);
    padding: 6px 16px;
    border-radius: 4px;
  }
`;
